module.exports = __webpack_public_path__ + "static/media/knowji_ai.db7846e0.png";